(function () {
  // Product gallery: a scroll-snap strip (swipe on touch, thumbnails everywhere) with a row of thumbnail buttons.
  var root = document.querySelector('[data-gallery]');
  if (!root) return;
  var track = root.querySelector('[data-gallery-track]');
  var slides = Array.prototype.slice.call(track.children);
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current = 0;
  var lockUntil = 0;   // while our own smooth scroll runs, scroll events must not move the active thumbnail back

  function setActive(i) {
    current = i;
    thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    var t = thumbs[i];
    if (t && t.parentElement) {                       // keep the active thumbnail visible in a scrolling row (row only, never the page)
      var row = t.parentElement;
      row.scrollTo({ left: t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
    }
  }
  function go(i, smooth) {
    if (i < 0 || i >= slides.length) return;
    lockUntil = Date.now() + (smooth && !reduce ? 900 : 120);
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    setActive(i);
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-gallery-thumb'), 10), true); });
  });

  // Swiping (or any scroll of the strip) updates the active thumbnail once it has settled.
  var settle;
  track.addEventListener('scroll', function () {
    clearTimeout(settle);
    settle = setTimeout(function () {
      if (Date.now() < lockUntil) return;
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      if (i !== current && i >= 0 && i < slides.length) setActive(i);
    }, 90);
  }, { passive: true });

  window.addEventListener('resize', function () { track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' }); });

  // A size with its own image switches the big image (main-product.liquid dispatches this when the size changes).
  document.addEventListener('fiorenci:variant-image', function (e) {
    var id = String(e.detail && e.detail.imageId);
    for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-image-id') === id) { go(i, true); return; }
  });

  var start = parseInt(root.getAttribute('data-start'), 10) || 0;
  if (start > 0) go(start, false);
})();
